module.exports = __webpack_public_path__ + "img/berts-logo-footer.566026d9.svg";